
import { FiltersRelativeDateMethod } from '../../utilities';
import { WorkOrderFilters } from '../../shared/workorder.filters';
import { FilterValue } from '../shared/filter';
import { JobGroupBy, JobSource, JobViewType } from './index';
import { SortJobOptions } from './job.sort.options';
import { SystemWorkOrderStatus } from './system.workorder.status';

export interface UserFilterValue extends FilterValue {
  technician?: boolean;
}

export interface StatusFilterValue extends FilterValue {
  isSystemStatus: boolean;
  systemStatus: SystemWorkOrderStatus;
  sortOrder: number;
  systemName: string;
}

export interface JobViewFilters extends WorkOrderFilters {

  _id?: string;

  viewType?: JobViewType;
  groupBy?: JobGroupBy;
  totalWorkOrders?: number;
  total?: number;
  sort?: SortJobOptions;
  displayType?: string;

  // Multi - Need to check data inside
  labels?: FilterValue[];
  text?: string;

  // Job Filters
  customers?: FilterValue[];
  priceBooks?: FilterValue[];
  billingCompanies?: FilterValue[];
  workCategories?: FilterValue[];
  jobTypes?: FilterValue[];
  priorities?: FilterValue[];
  zones?: FilterValue[];
  owners?: UserFilterValue[];
  fieldSupervisors?: UserFilterValue[];

  createdAt?: FiltersRelativeDateMethod;
  dueDate?: FiltersRelativeDateMethod;
  stageDueDate?: FiltersRelativeDateMethod;
  completedDate?: FiltersRelativeDateMethod;
  finalisedDate?: FiltersRelativeDateMethod;

  // Work Order Filters
  resources?: UserFilterValue[];
  statuses?: StatusFilterValue[];
  timezones?: string[];
  states?: string[];

  // Not Implemented
  overDueDate?: Date;
  dueBeforeDate?: Date;
  unassigned?: boolean;
  employees?: UserFilterValue[];
  technicians?: UserFilterValue[];

  claimTags?: FilterValue[];

  // Not sure what this is for
  finance?: FilterValue[];


}


export interface JobViewFiltersRaw extends JobViewFilters {
  jobNumbers: string[];
}

export interface WorkOrderFiltersRequest {
  source: JobSource;
  filter: WorkOrderFilters;
}

export interface SelectedItemRequest {
  source: JobSource;
  id: string;
}

export enum FilterFieldName {
  Customer = 'Customer',
  PriceBook = 'PriceBook',
  JobType = 'JobType',
  Priority = 'Priority',
  Technician = 'Technician',
  Owner = 'Owner',
  FieldSupervisor = 'FieldSupervisor',
  Status = 'Status',
  Label = 'Label',
  Zones = 'Zones',
  Resources = 'Resources',
  BillingCompanies = 'BillingCompanies',
  WorkCategories = 'WorkCategories',
  CreatedAt = 'CreatedAt',
  DueDate = 'DueDate',
  CompletedDate = 'CompletedDate',
  FinalisedDate = 'FinalisedDate',
}

export enum FinanceFilter {
  Invoiced = 'Invoiced',
  Billed = 'Billed'
}

export function isJobViewFiltersRefined(refinements: JobViewFilters): boolean {
  if (!refinements) return false;
  if (refinements.text && (refinements.text !== null || refinements.text === '')) return true;
  if (refinements.customers && refinements.customers.length) return true;
  if (refinements.billingCompanies && refinements.billingCompanies.length) return true;
  if (refinements.owners && refinements.owners.length) return true;
  if (refinements.priceBooks && refinements.priceBooks.length) return true;
  if (refinements.priorities && refinements.priorities.length) return true;
  if (refinements.statuses && refinements.statuses.length) return true;
  if (refinements.resources && refinements.resources.length) return true;
  if (refinements.jobTypes && refinements.jobTypes.length) return true;
  if (refinements.labels && refinements.labels.length) return true;
  if (refinements.zones && refinements.zones.length) return true;
  if (refinements.finance && refinements.finance.length) return true;
  if (refinements.fieldSupervisors && refinements.fieldSupervisors.length) return true;
  if (refinements.workCategories && refinements.workCategories.length) return true;

  if (refinements.createdAt) return true;
  if (refinements.dueDate) return true;
  if (refinements.completedDate) return true;
  if (refinements.finalisedDate) return true;
  return false;
}


